// extracted by mini-css-extract-plugin
export default {"discountCodeIntroduction":"Aldb_AEquwGt4Naeu054","discountCodeModal":"WnDQTA7BfSX5RzZgq6Pz","common_bganimation":"Vve53lqcXOu8i3cdd0Zl"};